import { Button } from '@missionlabs/smartagent-app-components'
import { useDispatch } from 'react-redux'

import useHasFeature, { AppFeatures } from 'hooks/useHasFeature'
import { toggleAmazonQ } from 'store/app/app.actions'

import { ReactComponent as AmazonQIcon } from '../../../images/amazon-q-logo.svg'

import styles from '../AmazonQ.module.scss'

const ToggleAmazonQButton = () => {
    const dispatch = useDispatch()

    const hasFeature = useHasFeature()

    const amazonQFeature = hasFeature(AppFeatures.AMAZON_Q)

    const onClick = () => dispatch(toggleAmazonQ())

    if (!amazonQFeature) return null

    return (
        <Button
            round
            className={styles.toggleAmazonQButton}
            aria-label="Show Amazon Q"
            onClick={onClick}
        >
            <AmazonQIcon className={styles.amazonQIcon} title="Amazon Q" />
        </Button>
    )
}

export default ToggleAmazonQButton
